// extracted by mini-css-extract-plugin
export default {"container":"ProcessingModal_container__OqUBb","animation":"ProcessingModal_animation__AripN","text":"ProcessingModal_text__B6sRn"};